import React, { useRef, useState } from "react";
import styles from "./ChartSelector.module.css";
import {
	primaryTextColor,
	secondaryTextColor,
	fw400,
	titleS,
} from "../../../Global.module.css";
import { useOutsideClick } from "../../../helpers/useOutsideClick";
import { getChartOptions } from "./helpers/getChartOptions";
import { getChartTypes } from "./helpers/getChartTypes";
import Charts from "./Charts.json";

export default function ChartSelector(props) {
	const [chartType, setChartType] = useState(Charts.AreaChart);

	const ref = useRef();

	useOutsideClick(ref, props.closeSelector);

	const chartSelected = (chartType) => {
		props.chartSelected(chartType);
		props.closeSelector();
	};

	return (
		<div className={styles.chartSelector} ref={ref}>
			<p
				className={`${styles.closeBtn} ${secondaryTextColor} ${fw400} ${titleS}`}
				onClick={props.closeSelector}
			>
				X
			</p>

			<div
				className={`${styles.optionList} ${primaryTextColor} ${fw400} ${titleS}`}
			>
				{getChartOptions(setChartType) || null}
			</div>
			{chartType ? (
				<div className={styles.contentBox}>
					<div className={styles.charts}>
						{getChartTypes(chartType, chartSelected) || null}
					</div>
				</div>
			) : null}
		</div>
	);
}
